import { ImageDisplaySetting } from '@/src/components/Upload';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { get } from 'lodash';
import React from 'react';
import css from './css.module.less';
const FocusPoint = (props) => {
  const { image, onChange, disable, className } = props;
  const imageSettingFocus = get(image, 'imageSetting.focus');
  const imageSettingLeft = get(image, 'imageSetting.left');
  const imageSettingRight = get(image, 'imageSetting.right');
  const imageSettingTop = get(image, 'imageSetting.top');
  const imageSettingBottom = get(image, 'imageSetting.bottom');
  const imageUrl = get(image, 'url');
  const [imageSettingVisible, setImageSettingVisible] = React.useState(false);
  const handleInImageSettingChange = ({ value, focalValue }) => {
    setImageSettingVisible(false);
    const { leftTop, leftBottom, rightBottom, rightTop } = value || {};
    const setting = {
      left: leftTop,
      right: rightBottom,
      top: rightTop,
      bottom: leftBottom,
    };
    const focus = focalValue;
    const imageSetting = {
      ...setting,
      focus,
    };
    const _image = { ...(image || {}), imageSetting };
    onChange({ image: _image });
  };
  return (
    <React.Fragment>
      {imageSettingVisible && (
        <ImageDisplaySetting
          src={imageUrl}
          value={
            imageSettingLeft &&
            imageSettingLeft &&
            imageSettingRight &&
            imageSettingTop
              ? {
                  leftTop: imageSettingLeft,
                  leftBottom: imageSettingBottom,
                  rightBottom: imageSettingRight,
                  rightTop: imageSettingTop,
                }
              : null
          }
          visible={imageSettingVisible}
          focalValue={imageSettingFocus}
          onCancel={() => setImageSettingVisible(false)}
          onOk={handleInImageSettingChange}
        />
      )}
      {!disable && image && (
        <div className={`${css.edit} ${className || ''}`}>
          <a onClick={() => setImageSettingVisible(true)}>
            {getI18nFromGeneral('general.imageFocusPointEdit.display_setting')}
          </a>
        </div>
      )}
    </React.Fragment>
  );
};

export default FocusPoint;
